export var OptionSymbol = Symbol('SyringeOptionSymbol');
export var registerSideOption = function registerSideOption(option, target) {
  Reflect.defineMetadata(OptionSymbol, option, target);
};